import Header from 'src/components/header/Header';
import { TUserTypes } from 'src/constants/user.constants';
import { useRef, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  useCalculateElementHeight,
  useGetIdentity,
  useToggleOpenModal,
  useUrlParamValue
} from 'src/hooks';
import { ConfirmModal, TDropdownOptions } from 'src/components/common';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { TDiscussionTypes } from 'src/components/chat/chat.type';
import { changeChatConversation, clearLocalChat, deleteProgramGroup, getGroups } from 'src/store/chat/chat.slice';
import { TDeleteProgramGroupActionRequest } from 'src/services/apiEndpoint.types.ts';
// import DiscussionList from './discussionList/DiscussionList';
// import { TDiscussionProps } from './discussion.types';
// import useGetProgramGroups from './discussionList/useGetProgramGroups.hook';
// import './discussion.scss';
// import useToggleOpenDiscussionMembersModal from '../../components/chat/discussion/chatMessages/chatMessagesHeader/useToggleOpenDiscussionMembersModal';
// eslint-disable-next-line import/no-duplicates
import {
  ChatList,
  ChatMessages,
  useToggleCreateEditGroupModal,
  useToggleManageGroupModalModal
} from '../../components/chat';
import ChatMessagesGroup from '../../components/chat/discussion/chatMessages/ChatMessages';
// import EditProgramGroup from './editProgramGroup/EditProgramGroup';

import './chat.scss';

const Chat = () => {
  // Hooks
  const chatBodyRef = useRef<HTMLDivElement>(null);
  const { paramValue } = useUrlParamValue();
  const { getIdentities } = useGetIdentity();

  const selectedUserId: string = paramValue({ paramName: 'userId' }) || '';
  const selectedUserType = paramValue({ paramName: 'userType' }) as unknown as TUserTypes;
  const discussionType: TDiscussionTypes = paramValue({
    paramName: 'chatType'
  }) as unknown as TDiscussionTypes;
  const groupId: string = paramValue({ paramName: 'groupId' }) || '';
  const { loggedInUserId, loggedInUserType, loggedInCompanyId, authenticatedId } = getIdentities();

  const showChatWindowOnMobile: boolean = Boolean((selectedUserId && selectedUserType) || (discussionType && groupId));
  // Get program groups
  const { GroupParticipants, localChat } = useAppSelector((store) => store.chat);
  const dispatch = useAppDispatch();
  const [localChatData, setLocalChatData] = useState<any>(null)
  const [isViewerOwner, setIsViewerOwner] = useState<boolean>(
    GroupParticipants?.[0]?.ownerId === authenticatedId
  );

  const handleGetGroups = () => {
    const payload: any = {
      userId: authenticatedId,
      userType: loggedInUserType
    };

    dispatch(getGroups(payload));
  };
  useEffect(() => {
    handleGetGroups();
  }, []);
  useEffect(() => {
    if (localChat) {
      setLocalChatData(localChat)
      dispatch(changeChatConversation({ conversation: localChat }))
      return () => {
        // dispatch(clearLocalChat())
      }
    }
  }, [localChat])

  return (
    <div className="chat-page">
      <Header />
      <div className="chat-page__body" ref={chatBodyRef}
      // style={{ height: `${elementHeight}px` }}
      >
        <ChatList
          selectedUserId={selectedUserId}
          selectedUserType={selectedUserType}
          showChatList={!showChatWindowOnMobile}
          loggedInUserId={loggedInUserId}
          loggedInCompanyId={loggedInCompanyId}
          authenticatedId={authenticatedId}
          loggedInUserType={loggedInUserType}
          localChat={localChatData}
        />
        {groupId ? (
          <ChatMessagesGroup
            discussionType={discussionType}
            groupId={groupId}
          // headerDropdownOptions={headerDropdownOptions}

          // programId={programId}
          // companyId={companyId}
          />
        ) : (
          <ChatMessages
            selectedUserId={selectedUserId}
            selectedUserType={selectedUserType}
            showChatWindowOnMobile={showChatWindowOnMobile}
            directMessageContext="directMessage"
            localChat={localChatData}
            setLocalChatData={setLocalChatData}
          />
        )}
      </div>
    </div>
  );
};

export default Chat;
